<template>
  <el-row>
    <el-col :lg="12" :md="24">
      <el-card class="box-card" ref="card" shadow="never">
        <el-divider content-position="left">【{{ brandName }}】 <span> 红人合作密度Top10</span>
          <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                   title="点击刷新"
                   @click="getData">
            <i class="el-icon-refresh-right"/>
          </el-link>
        </el-divider>

        <el-table class="dashboard-table"
                  :data="data"
                  :row-class-name="rowClassName"
                  :row-style="{ border: 'none',padding:'15px 0'}"
                  :cell-style="{ border: 'none'}"
                  style="width: 100%">
          <el-table-column prop="index" label="排名"/>
          <el-table-column prop="artist_name" label="红人"/>
          <el-table-column prop="order_money" :label="`订单金额\u2002(元)\u2002\u2002\u2002`">
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_count" label="订单量" align="right" sortable="custom"/>
        </el-table>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import {detailArtist} from "@/api/dashboard";

export default {
  name: "ChartBrandArtistRank",
  props: {
    year: [Number, String],
    brandName: {
      type: [String],
      default: ''
    },
    organizationId: {
      type: [Number, String],
      default: 'ALL'
    },
  },
  data() {
    return {
      data: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.data = [];
      detailArtist({
        year: this.year,
        brand_name: this.brandName,
        organization_id: this.organizationId,
      }).then(res => {
        this.data = res.model.data;
      })
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
    },
  }
}
</script>

<style scoped>

</style>
